import { Link } from "react-router-dom";
import { RouteList } from "Routes";
import { IconText } from "components/IconText";
import { CreateGameModal, CreateGameModalButton } from "components/modals/CreateGameModal";
import { Fragment } from "react";

export const MainActions = () => (
    <Fragment>
        <div className="hstack align-self-center align-self-lg-start gap-2 align-items-center">
            <Link to={RouteList.GamesPlay} className="btn btn-primary icon-link">
                <IconText icon="fas fa-play" text="Play" />
            </Link>

            <CreateGameModalButton className="btn btn-dark icon-link" />
        </div>

        <CreateGameModal />
    </Fragment>
);
